// extracted by mini-css-extract-plugin
export var numpadContainer = "_q8-1";
export var phoneButton = "_q8-0";